

































import { Component, Mixins, Prop } from "vue-property-decorator";
import { Color } from "../../../../../../base/domain/drawing";
import { ModelEditableMixin } from "../../../../../../base/components/system/mixins";
import { RadioButtonSelector } from "../../../../../../base/components/system/selectors";
import { IConfiguration, NewObjectKeys } from "../../../../../domain/configuration";
import { FormatPageStructureEditableMixin } from "../../mixins";
import { default as FormatObjectOrderTool } from "./FormatObjectOrderTool.vue";
import { default as FormatObjectLocateTool } from "./FormatObjectLocateTool.vue";
import { default as FormatObjectPropertyEditTool } from "./FormatObjectPropertyEditTool.vue";
import { LocatorKeys, ILocatorDefinition } from "./locators";

interface ISelectedMode {
  name: string;
  class: string[] | string;
  description: string;
  label?: string;
  locatorKey?: LocatorKeys;
}

@Component({
  components: {
    RadioButtonSelector,
    FormatObjectOrderTool,
    FormatObjectLocateTool,
    FormatObjectPropertyEditTool,
  },
})
export default class FormatObjectEditTool extends Mixins(ModelEditableMixin, FormatPageStructureEditableMixin) {
  @Prop()
  isVisible: boolean;

  $configuration!: IConfiguration;

  data(): any {
    return {
      userSelectedMode: FormatObjectEditTool._defaultMode,
      shouldCreateContinuously: false,
      pallet: [ // TODO: 設定から取る?(Docu2Webにもその記載あり.)
        new Color("#FF0000"),
        new Color("#FFFF00"),
        new Color("#00FF00"),
        new Color("#00FFFF"),
        new Color("#0000FF"),
        new Color("#FF00FF"),
        new Color("#FFFFFF"),
        new Color("#000000"),
      ],
    };
  }
  userSelectedMode: ISelectedMode;
  shouldCreateContinuously: boolean;
  pallet: Color[];

  get selectedMode(): ISelectedMode {
    return this.isVisible
      ? this.userSelectedMode
      : FormatObjectEditTool._defaultMode;
  }

  set selectedMode(value: ISelectedMode) {
    this.userSelectedMode = value;
  }

  get modes(): ISelectedMode[] {
    return FormatObjectEditTool._modes.filter(m => !m.locatorKey || !!this.locators[m.locatorKey]);
  }

  get locators(): { [key in LocatorKeys]: ILocatorDefinition } {
    // 複数オプションの利用可否絞り込みのみここで行う.(単一オプションの場合のkey自体の絞り込みはここまでに行われてる想定.)
    const configurations = this.$configuration.formatEditor.behavior.format.editor.newObjects;
    const newHisItemOptions = [
      configurations.NewHisText.isEnable ? {
        key: "NewHisText",
        name: "テキスト",
        description: "テキスト形式のHIS項目",
      } : undefined,
      configurations.NewHisDate.isEnable ? {
        key: "NewHisDate",
        name: "日付",
        description: "日付形式のHIS項目",
      } : undefined,
      configurations.NewHisTime.isEnable ? {
        key: "NewHisTime",
        name: "時刻",
        description: "時刻形式のHIS項目",
      } : undefined,
    ].filter(o => !!o).map(o => o as { key: NewObjectKeys, name: string, description: string });
    const newUserDefinedItemOptions = [
      configurations.NewUserDefinedText.isEnable ? {
        key: "NewUserDefinedText",
        name: "テキスト",
        description: "テキスト形式のユーザ定義",
      } : undefined,
      configurations.NewUserDefinedDate.isEnable ? {
        key: "NewUserDefinedDate",
        name: "日付",
        description: "日付形式のユーザ定義",
      } : undefined,
    ].filter(o => !!o).map(o => o as { key: NewObjectKeys, name: string, description: string });
    return {
      NewHisItem: 0 < newHisItemOptions.length ? {
        type: "Rectangles",
        option: newHisItemOptions,
      } : undefined,
      NewFreeText: configurations.NewFreeText.isEnable ? {
        type: "Rectangle",
        option: "NewFreeText",
      } : undefined,
      NewText: configurations.NewText.isEnable ? {
        type: "Rectangle",
        option: "NewText",
      } : undefined,
      NewFixedText: configurations.NewFixedText.isEnable ? {
        type: "Rectangle",
        option: "NewFixedText",
      } : undefined,
      NewDate: configurations.NewDate.isEnable ? {
        type: "Rectangle",
        option: "NewDate",
      } : undefined,
      NewTime: configurations.NewTime.isEnable ? {
        type: "Rectangle",
        option: "NewTime",
      } : undefined,
      NewNumberText: configurations.NewNumberText.isEnable ? {
        type: "Rectangle",
        option: "NewNumberText",
      } : undefined,
      NewCheckBox: configurations.NewCheckBox.isEnable ? {
        type: "Rectangle",
        option: "NewCheckBox",
      } : undefined,
      NewCircleSelect: configurations.NewCircleSelect.isEnable ? {
        type: "Rectangle",
        option: "NewCircleSelect",
      } : undefined,
      NewComboBox: configurations.NewComboBox.isEnable ? {
        type: "Rectangle",
        option: "NewComboBox",
      } : undefined,
      NewRoll: configurations.NewRoll.isEnable ? {
        type: "Rectangle",
        option: "NewRoll",
      } : undefined,
      NewUserDefinedItem: 0 < newUserDefinedItemOptions.length ? {
        type: "Rectangles",
        option: newUserDefinedItemOptions,
      } : undefined,
      NewExternalData: configurations.NewExternalData.isEnable ? {
        type: "ExternalData",
        option: "NewExternalData",
      } : undefined,
      NewCalculateExpression: configurations.NewCalculateExpression.isEnable ? {
        type: "Rectangle",
        option: "NewCalculateExpression",
      } : undefined,
      NewConditionalExpression: configurations.NewConditionalExpression.isEnable ? {
        type: "Rectangle",
        option: "NewConditionalExpression",
      } : undefined,
      NewDurationExpression: configurations.NewDurationExpression.isEnable ? {
        type: "Rectangle",
        option: "NewDurationExpression",
      } : undefined,
      NewSpanExpression: configurations.NewSpanExpression.isEnable ? {
        type: "Rectangle",
        option: "NewSpanExpression",
      } : undefined,
      NewImageArea: configurations.NewImageArea.isEnable ? {
        type: "Rectangle",
        option: "NewImageArea",
      } : undefined,
      NewImage: configurations.NewImage.isEnable ? {
        type: "Rectangle",
        option: "NewImage",
      } : undefined,
      NewStamp: configurations.NewStamp.isEnable ? {
        type: "NotImplemented",                   // Docu2Web未実装.E大でも使わないので優先度は低.
      } : undefined,
      NewRangeOfMotionSet: configurations.NewRangeOfMotionGraph.isEnable && configurations.NewRangeOfMotionText.isEnable ? {
        type: "RangeOfMotion",
        option: "NewRangeOfMotionGraph",
      } : undefined,
      NewBarcode: configurations.NewBarcode.isEnable ? {
        type: "Rectangle",
        option: "NewBarcode",
      } : undefined,
      NewPositionCorrection: configurations.NewPositionCorrection.isEnable ? {
        type: "PositionCorrection",
        option: "NewPositionCorrection",
      } : undefined,
      NewJoinedText: configurations.NewJoinedText.isEnable ? {
        type: "Rectangle",
        option: "NewJoinedText",
      } : undefined,
      NewGraph: configurations.NewGraph.isEnable ? {
        type: "Rectangle",
        option: "NewGraph",
      } : undefined,
      NewDateCompareExpression: configurations.NewDateCompareExpression.isEnable ? {
        type: "Rectangle",
        option: "NewDateCompareExpression",
      } : undefined,
      NewExternalScript: configurations.NewExternalScript.isEnable ? {
        type: "Rectangle",
        option: "NewExternalScript",
      } : undefined,
      NewSign: configurations.NewSign.isEnable ? {
        type: "NotImplemented",                   // Docu2Web未実装.E大でも使わないので優先度は低.
      } : undefined,
      NewDesignatedDoctorNumberText: configurations.NewDesignatedDoctorNumberText.isEnable ? {
        type: "Rectangle",
        option: "NewDesignatedDoctorNumberText",
      } : undefined,
      NewRichText: configurations.NewRichText.isEnable ? {
        type: "NotImplemented",                   // E大に出荷してるファイル版にはないので優先度は低.
      } : undefined, 
      NewNewPage: configurations.NewNewPage.isEnable ? {
        type: "NotImplemented",                   // E大に出荷してるファイル版にはないので優先度は低.
      } : undefined, 
      NewLine: configurations.NewLine.isEnable ? {
        type: "Vector",
        option: "NewLine",
      } : undefined,
      NewArrorLine: configurations.NewArrorLine.isEnable ? {
        type: "NotImplemented",                   // E大に出荷してるファイル版にはないので優先度は低.
      } : undefined, 
      NewBoxLine: configurations.NewBoxLine.isEnable ? {
        type: "Rectangle",
        option: "NewBoxLine",
      } : undefined,
      NewCircle: configurations.NewCircle.isEnable ? {
        type: "Rectangle",
        option: "NewCircle",
      } : undefined,
    };
  }

  get isLocating(): boolean {
    return !!this.userSelectedMode
        && !!this.userSelectedMode.locatorKey;
  }

  get locatorKey(): string {
    return this.isLocating
      ? this.userSelectedMode.locatorKey
      : null;
  }

  onLocated(shouldLocateContinuously: boolean): void {
    if (!shouldLocateContinuously) {
      this.selectedMode = FormatObjectEditTool._defaultMode;
    }
  }

  private static readonly _modes: ISelectedMode[] = [
    {
      name: "オブジェクト選択",
      class: "select",
      description: "配置済のオブジェクトを選択して編集します。",
    },
    {
      name: "直線オブジェクト追加",
      class: "new-line",
      description: "新しい直線オブジェクトを追加します。",
      locatorKey: "NewLine",
    },
    /* E大に出荷してるファイル版にはないので優先度は低. 
    {
      name: "矢印オブジェクト追加",
      class: "new-arrow-line",
      description: "新しい矢印オブジェクトを追加します。",
      locatorKey: "NewArrorLine",
    },
    */
    {
      name: "矩形オブジェクト追加",
      class: "new-box-line",
      description: "新しい矩形オブジェクトを追加します。",
      locatorKey: "NewBoxLine",
    },
    {
      name: "円オブジェクト追加",
      class: "new-circle",
      description: "新しい円オブジェクトを追加します。",
      locatorKey: "NewCircle",
    },
    {
      name: "HIS項目",
      class: [ "new-his-item", "large" ],
      description: "新しいHIS項目オブジェクトを追加します。",
      label: "HIS項目",
      locatorKey: "NewHisItem",
    },
    {
      name: "フリー入力テキストオブジェクト追加",
      class: [ "new-free-text", "large" ],
      description: "新しいフリー入力テキストオブジェクトを追加します。",
      label: "ﾌﾘｰ入力",
      locatorKey: "NewFreeText",
    },
    {
      name: "テキストオブジェクト追加",
      class: [ "new-text", "large" ],
      description: "新しいテキストオブジェクトを追加します。",
      label: "ﾃｷｽﾄﾎﾞｯｸｽ",
      locatorKey: "NewText",
    },
    {
      name: "固定テキストオブジェクト追加",
      class: [ "new-fixed-text", "large" ],
      description: "新しい固定テキストオブジェクトを追加します。",
      label: "固定ﾃｷｽﾄ",
      locatorKey: "NewFixedText",
    },
    {
      name: "日付オブジェクト追加",
      class: [ "new-date", "large" ],
      description: "新しい日付オブジェクトを追加します。",
      label: "日付",
      locatorKey: "NewDate",
    },
    {
      name: "時刻オブジェクト追加",
      class: [ "new-time", "large" ],
      description: "新しい時刻オブジェクトを追加します。",
      label: "時刻",
      locatorKey: "NewTime",
    },
    {
      name: "数値オブジェクト追加",
      class: [ "new-number-text", "large" ],
      description: "新しい数値オブジェクトを追加します。",
      label: "数値",
      locatorKey: "NewNumberText",
    },
    {
      name: "チェックボックスオブジェクト追加",
      class: [ "new-check-box", "large" ],
      description: "新しいチェックボックスオブジェクトを追加します。",
      label: "ﾁｪｯｸﾎﾞｯｸｽ",
      locatorKey: "NewCheckBox",
    },
    {
      name: "円選択オブジェクト追加",
      class: [ "new-circle-select", "large" ],
      description: "新しい円選択オブジェクトを追加します。",
      label: "円選択",
      locatorKey: "NewCircleSelect",
    },
    {
      name: "リスト選択オブジェクト追加",
      class: [ "new-combo-box", "large" ],
      description: "新しいリスト選択オブジェクトを追加します。",
      label: "ﾘｽﾄ選択",
      locatorKey: "NewComboBox",
    },
    {
      name: "クリック選択オブジェクト追加",
      class: [ "new-roll", "large" ],
      description: "新しいクリック選択オブジェクトを追加します。",
      label: "ｸﾘｯｸ選択",
      locatorKey: "NewRoll",
    },
    {
      name: "ユーザ定義項目オブジェクト追加",
      class: [ "new-user-defined-item", "large" ],
      description: "新しいユーザ定義項目オブジェクトを追加します。",
      label: "ﾕｰｻﾞ定義",
      locatorKey: "NewUserDefinedItem",
    },
    {
      name: "外部データオブジェクト追加",
      class: [ "new-external-data", "large" ],
      description: "新しい外部データオブジェクトを追加します。",
      label: "外部ﾃﾞｰﾀ",
      locatorKey: "NewExternalData",
    },
    {
      name: "計算式オブジェクト追加",
      class: [ "new-calculate-expression", "large" ],
      description: "新しい計算式オブジェクトを追加します。",
      label: "計算式",
      locatorKey: "NewCalculateExpression",
    },
    {
      name: "条件式オブジェクト追加",
      class: [ "new-conditional-expression", "large" ],
      description: "新しい条件式オブジェクトを追加します。",
      label: "条件式",
      locatorKey: "NewConditionalExpression",
    },
    {
      name: "期間日数オブジェクト追加",
      class: [ "new-duration-expression", "large" ],
      description: "新しい期間日数オブジェクトを追加します。",
      label: "期間日数",
      locatorKey: "NewDurationExpression",
    },
    {
      name: "経過時間オブジェクト追加",
      class: [ "new-span-expression", "large" ],
      description: "新しい経過時間オブジェクトを追加します。",
      label: "経過時間",
      locatorKey: "NewSpanExpression",
    },
    {
      name: "画像エリアオブジェクト追加",
      class: [ "new-image-area", "large" ],
      description: "新しい画像エリアオブジェクトを追加します。",
      label: "画像ｴﾘｱ",
      locatorKey: "NewImageArea",
    },
    {
      name: "固定画像オブジェクト追加",
      class: [ "new-image", "large" ],
      description: "新しい固定画像オブジェクトを追加します。",
      label: "固定画像",
      locatorKey: "NewImage",
    },
    /* // Docu2Web未実装.E大でも使わないので優先度は低.
    {
      name: "印影オブジェクト追加",
      class: [ "new-stamp", "large" ],
      description: "新しい印影オブジェクトを追加します。",
      locatorKey: "NewStamp",
    },
    */
    {
      name: "関節可動域ブジェクト追加",
      class: [ "new-range-of-motion-graph", "large" ],
      description: "新しい関節可動域オブジェクトを追加します。",
      label: "関節可動域",
      locatorKey: "NewRangeOfMotionSet",
    },
    {
      name: "バーコードオブジェクト追加",
      class: [ "new-barcode", "large" ],
      description: "新しいバーコードオブジェクトを追加します。",
      label: "ﾊﾞｰｺｰﾄﾞ",
      locatorKey: "NewBarcode",
    },
    {
      name: "位置補正オブジェクト追加",
      class: [ "new-position-correction", "large" ],
      description: "新しい位置補正オブジェクトを追加します。",
      label: "位置補正",
      locatorKey: "NewPositionCorrection",
    },
    {
      name: "結合テキストオブジェクト追加",
      class: [ "new-joined-text", "large" ],
      description: "新しい結合テキストオブジェクトを追加します。",
      label: "結合ﾃｷｽﾄ",
      locatorKey: "NewJoinedText",
    },
    {
      name: "グラフオブジェクト追加",
      class: [ "new-graph", "large" ],
      description: "新しいグラフオブジェクトを追加します。",
      label: "折れ線ｸﾞﾗﾌ",
      locatorKey: "NewGraph",
    },
    {
      name: "日付比較オブジェクト追加",
      class: [ "new-date-compare-expression", "large" ],
      description: "新しい日付比較オブジェクトを追加します。",
      label: "日付比較",
      locatorKey: "NewDateCompareExpression",
    },
    {
      name: "外部処理オブジェクト追加",
      class: [ "new-external-script", "large" ],
      description: "新しい外部処理オブジェクトを追加します。",
      label: "外部処理",
      locatorKey: "NewExternalScript",
    },
    /* // Docu2Web未実装.E大でも使わないので優先度は低.
    {
      name: "サインオブジェクト追加",
      class: [ "new-sign", "large" ],
      description: "新しいサインオブジェクトを追加します。",
      locatorKey: "NewSign",
    },
    */
    {
      name: "指定医番号オブジェクト追加",
      class: [ "new-designated-doctor-number-text", "large" ],
      description: "新しい指定医番号オブジェクトを追加します。",
      label: "指定医番号",
      locatorKey: "NewDesignatedDoctorNumberText",
    },
    /* E大に出荷してるファイル版にはないので優先度は低. 
    {
      name: "リッチテキストオブジェクト追加",
      class: [ "new-rich-text", "large" ],
      description: "新しいリッチテキストオブジェクトを追加します。",
      locatorKey: "NewRichText",
    },
    */
    /* E大に出荷してるファイル版にはないので優先度は低. 
    {
      name: "改頁オブジェクト追加",
      class: [ "new-new-page", "large" ],
      description: "新しい改頁オブジェクトを追加します。",
      locatorKey: "NewNewPage",
    },
    */
  ];

  private static readonly _defaultMode: ISelectedMode = FormatObjectEditTool._modes[0];
}
